import {APP_INITIALIZER, InjectionToken, Provider} from '@angular/core';
import {WalletOnPaymentSucceededSubscriber} from "../../application/subscribers/wallet-on-payment-succeed.subscriber";
import {RouteVisibilityPort} from "@features/wallet/application/ports/route-visibility.port";
import {RouterVisibilityAdapter} from "@features/wallet/infrastructure/adapters/router-visibility.adapter";
import {WalletRepository} from "@features/wallet/domain/repository/wallet.repository";
import {
  WalletOnStatusChangedSubscriber
} from "@features/wallet/application/subscribers/wallet-on-status-changed.subscriber";
import {
  WalletOnCartTotalChangedSubscriber
} from "@features/wallet/application/subscribers/wallet-on-cart-total-changed.subscriber";
import {WALLET_STORE_STORAGE} from "../tokens/wallet-store-storage.token";
import {WalletStore, WalletState} from "@features/wallet/application/store/wallet.store";
import {HttpWalletAdapter} from "@features/wallet/infrastructure/adapters/http-wallet.adapter";
import {StoreIndexedDbStorage} from '@platform/storage/infrastructure/storage-indexdb.storage';
import {Logger} from 'src/app/core/interfaces/Logger';
import {StorageSynchronizer} from '@platform/storage/application/storage.synchronizer';
import {WalletStatus} from '@features/wallet/application/store/wallet.store';

export const DOMAIN_SUBSCRIBERS = new InjectionToken<unknown[]>('DOMAIN_SUBSCRIBERS');

export const WALLET_PROVIDERS: Provider[] = [
  {
    provide: WalletRepository,
    useClass: HttpWalletAdapter,
  },
  {
    provide: RouteVisibilityPort,
    useClass: RouterVisibilityAdapter
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: WalletOnCartTotalChangedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: WalletOnStatusChangedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: WalletOnPaymentSucceededSubscriber,
    multi: true
  },
  {
    provide: WALLET_STORE_STORAGE,
    useFactory: (logger: Logger) => new StoreIndexedDbStorage<WalletState>(logger, 'wallet'),
    deps: [Logger],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: (storage: StoreIndexedDbStorage<WalletState>, store: WalletStore) =>
      new StorageSynchronizer<WalletState>(storage, store).sync({when: (state: WalletState) => state.status === WalletStatus.ACTIVE}),
    deps: [WALLET_STORE_STORAGE, WalletStore],
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (subscribers: unknown[]) => () => void subscribers,
    deps: [DOMAIN_SUBSCRIBERS]
  }
];
